import { ref, computed, toValue } from 'vue'
import * as turf from '@turf/turf'

export function useYMapCircle (center, radius, options) {
    // console.log(options)

    const {YMapFeature, YMapCollection} = ymaps3

    const areaDesc = {
        fillColor: options.style.fill,
        strokeColor: options.style.stroke[0]?.color || null,
        strokeWidth: options.style.stroke[0]?.width || null
    }

    // Окружность
    const yMapCircle = ref(new YMapCollection({}))

    // Праметры окружности
    const yMapCircleCenter = ref(center)
    const yMapCircleRadius = ref(radius)
    
    // Кнопки управления
    const centerButton = ref(null)
    const radiusButton = ref(null)

    // Объект окружности
    const circle = new YMapFeature({
        geometry: getCircleGeoJSON(yMapCircleCenter.value, yMapCircleRadius.value),
        style: options.style
    })

    if(options.editable == false) {
        yMapCircle.value = circle
    }

    yMapCircle.value.area = areaDesc
    yMapCircle.value.area.type = "circle"
    yMapCircle.value.area.center = center
    yMapCircle.value.area.radius = radius

    if(options.uuid) yMapCircle.value.area.uuid = options.uuid

    // GeoJSON для круга
    function getCircleGeoJSON(center, radiusMeters) {
        const {geometry} = turf.circle(center, radiusMeters, {units: 'meters'})

        return geometry
    }

    function yMapCircleMoveCenter(coordinates) {
        yMapCircleCenter.value = coordinates
        yMapCircle.value.area.center = yMapCircleCenter.value

        circle.update({
            geometry: getCircleGeoJSON(coordinates, yMapCircleRadius.value)
        })

        radiusButton.value.update({
            coordinates: circle.geometry.coordinates[0][0]
        })
    }

    function yMapCircleMoveRadius(coordinates) {
        yMapCircleRadius.value = turf.distance(yMapCircleCenter.value, coordinates, {units: 'meters'})
        yMapCircle.value.area.radius = yMapCircleRadius.value

        circle.update({
            geometry: getCircleGeoJSON(yMapCircleCenter.value, yMapCircleRadius.value)
        })
    }

    // Подключение кнопок редактирования (сентром и радиусом)
    const addControlButtons = async () => {
        const {YMapDefaultMarker} = await ymaps3.import('@yandex/ymaps3-default-ui-theme')

        centerButton.value = new YMapDefaultMarker({
            iconName: 'fallback',
            size: 'micro', // noraml, small, micro
            draggable: true,
            onDragMove: yMapCircleMoveCenter,
            coordinates: yMapCircleCenter.value
        })
    
        radiusButton.value = new YMapDefaultMarker({
            iconName: 'fallback',
            size: 'micro', // noraml, small, micro
            draggable: true,
            onDragMove: yMapCircleMoveRadius,
            coordinates: circle.geometry.coordinates[0][0]
        })

        yMapCircle.value.addChild(centerButton.value)
        yMapCircle.value.addChild(radiusButton.value)
    }

    if(options.editable == true) {
        addControlButtons()

        yMapCircle.value.addChild(circle)
    }   

    return {
        yMapCircle,
        yMapCircleCenter,
        yMapCircleRadius,
        yMapCircleMoveRadius
    }
}